<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g>
   <path class="fil0" d="M3001.81 3242.39l-1763.9 0 0 -2244.98 1763.9 0 0 2244.98zm0 -2565.71l-1763.9 0c-177.03,0 -320.67,143.64 -320.67,320.73l-0.06 2244.98c0.06,177.03 143.7,320.67 320.79,320.67l1763.84 0c177.09,0 320.72,-143.64 320.72,-320.73l0 -2244.92c0,-177.09 -143.63,-320.73 -320.72,-320.73l0 0zm-481.1 -641.4l-1924.26 0c-177.03,-0.06 -320.66,143.58 -320.66,320.67l0 2244.98 320.66 0 0 -2244.98 1924.26 0 0 -320.67zm285.26 1891.03c-23.9,-350.42 -321.22,-520.32 -645.1,-520.32 -445.99,0 -700.84,315.91 -700.84,743.32 0,411.47 278.74,703.49 692.88,703.49 361.04,0 613.24,-199.1 661.02,-562.8l-363.69 0c-23.9,167.25 -124.78,278.75 -299.99,278.75 -236.27,0 -313.25,-236.27 -313.25,-432.72 0,-201.76 79.64,-445.99 321.22,-445.99 156.62,0 254.85,82.3 278.74,236.27l369.01 0z"/>
  </g>
 </g>
</svg>
